import React, { useMemo } from "react";

import { DesignToolT } from "components/mui-styled-components/DesignToolSelector";
import BatteryOnlyProposalDisplay from "./BatteryOnlyProposalDisplay";
import NonVisionProposalDisplay from "./NonVisionProposalDisplay";
import VisionAuroraDisplay from "./VisionAuroraDisplay";
import VisionProposalTeamDisplay from "./VisionProposalTeamDisplay";
import VisionSelfDesignDisplay from "./VisionSelfDesignDisplay";
import * as S from "./styles";

type RequestCompletePropsT = {
  isVisionRequestSubmitted: boolean;
  isVisionSelfDesign: boolean;
  isBatteryOnly?: boolean;
  submittedDesignTool?: DesignToolT;
};

const RequestComplete = ({
  isVisionRequestSubmitted,
  isVisionSelfDesign,
  isBatteryOnly = false,
  submittedDesignTool = "vision",
}: RequestCompletePropsT) => {
  const requestCompleteDisplay = useMemo(() => {
    // Ahead of every other branch: Battery-Only skips the design queue, and the design-team,
    // aurora and non-vision screens all promise a returned design. The seller is also never
    // shown the Design Method question, so isVisionSelfDesign stays false and cannot stand in.
    if (isBatteryOnly) return <BatteryOnlyProposalDisplay />;
    if (isVisionSelfDesign) return <VisionSelfDesignDisplay />;
    if (isVisionRequestSubmitted && submittedDesignTool === "aurora") return <VisionAuroraDisplay />;
    if (isVisionRequestSubmitted) return <VisionProposalTeamDisplay />;
    return <NonVisionProposalDisplay />;
  }, [isVisionRequestSubmitted, isVisionSelfDesign, isBatteryOnly, submittedDesignTool]);

  return <S.RequestCompleteContainer>{requestCompleteDisplay}</S.RequestCompleteContainer>;
};

export default RequestComplete;
